import { useEffect, useState, useRef } from 'react';

import { fetchIframeContent } from '../Paywall/PaywallPopup/helpers/fetchIframeContent';

function useChameleonExperiment({
  url,
  shouldRender,
}: {
  url: string;
  shouldRender: boolean;
}) {
  const [content, setContent] = useState();
  const iframeRef = useRef<HTMLIFrameElement>(null);

  useEffect(() => {
    (async () => {
      if (!shouldRender) {
        return;
      }
      try {
        const iframeContent = await fetchIframeContent(url);
        setContent(iframeContent);
      } catch (error) {
        throw Error('Unable to load iframe content');
      }
    })();
  }, [url, shouldRender]);

  useEffect(() => {
    if (!iframeRef.current) {
      return;
    }
    const iframeDoc = iframeRef.current.contentDocument;

    if (!iframeDoc || !content) {
      return;
    }

    iframeDoc.open();
    iframeDoc.writeln(content);
    iframeDoc.close();
  }, [content]);

  // eslint-disable-next-line jsx-a11y/iframe-has-title
  return shouldRender ? <iframe ref={iframeRef} frameBorder="0" /> : null;
}

export { useChameleonExperiment };
